var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYouTubeRounded(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "YouTube",
    transform: "translate(-898 -1072)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Surface",
    width: 44,
    height: 44,
    rx: 22,
    transform: "translate(898 1072)",
    fill: "#f44336"
  }), /*#__PURE__*/React.createElement("g", {
    id: "email-24px",
    transform: "translate(908 1082)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7365",
    "data-name": "Path 7365",
    d: "M0,0H24V24H0Z",
    fill: "rgba(0,0,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "icons8-play-button",
    d: "M21.582,6.186a2.506,2.506,0,0,0-1.768-1.768C18.254,4,12,4,12,4s-6.254,0-7.814.418A2.506,2.506,0,0,0,2.418,6.186,35.643,35.643,0,0,0,2,12a35.643,35.643,0,0,0,.418,5.814,2.506,2.506,0,0,0,1.768,1.768C5.746,20,12,20,12,20s6.254,0,7.814-.418a2.5,2.5,0,0,0,1.768-1.768A35.643,35.643,0,0,0,22,12,35.643,35.643,0,0,0,21.582,6.186ZM10,14.6V9.4a.5.5,0,0,1,.75-.433l4.5,2.6a.5.5,0,0,1,0,.866l-4.5,2.6A.5.5,0,0,1,10,14.6Z",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYouTubeRounded);
export default __webpack_public_path__ + "static/media/YouTubeRounded.efd288fad92a64b008395896297d5148.svg";
export { ForwardRef as ReactComponent };